import {
  FormRichTextEditor,
  type FormRichTextEditorProps,
} from '@exam-management/rich-text-editor';
import { type FieldValues } from 'react-hook-form';

import { useUploadImageForSingleQuestionCreation } from '../../hooks';

export interface ReferenceFieldProps<TFieldValues extends FieldValues>
  extends Pick<FormRichTextEditorProps<TFieldValues>, 'name' | 'required'> {
  questionId?: string;
  taskId: string;
}

export default function ReferenceField<TFieldValues extends FieldValues>(
  props: Readonly<ReferenceFieldProps<TFieldValues>>,
) {
  const { name, required: isRequired, taskId, questionId } = props;

  const { handleUpload, loading: isLoading } = useUploadImageForSingleQuestionCreation({
    questionId,
    taskId,
  });

  return (
    <FormRichTextEditor
      label='หนังสืออ้างอิง'
      onImageUpload={handleUpload}
      loading={isLoading}
      name={name}
      placeholder='กรอกหนังสืออ้างอิง'
      required={isRequired}
      controls={[
        ['bold', 'italic', 'underline'],
        ['alignLeft', 'alignCenter', 'alignRight'],
        ['bulletList', 'numberList'],
      ]}
    />
  );
}
